import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-kanika',
  templateUrl: './kanika.component.html',
  styleUrls: ['./kanika.component.scss']
})
export class KanikaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getKanika();
  }

}
